// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
import {
	createStore,
	createContainer,
	createActionsHook,
	createStateHook,
} from '@atlassian/react-sweet-state';
import { initialState } from '../../common/constants.tsx';
import type { Actions, State } from '../../common/types.tsx';
import * as actions from '../actions/index.tsx';

const store = createStore<State, Actions>({
	name: 'issue-transition.issue-transition-form.use-trigger-issue-transition-modal',
	initialState,
	actions,
});

export const TriggerIssueTransitionModalContainer = createContainer(store);
export const useTriggerIssueTransitionModalActions = createActionsHook(store);
export const useTriggerIssueTransitionModalState = createStateHook(store);
